import { ICellRendererParams } from 'ag-grid-community';

export interface CustomCellRendererParams extends ICellRendererParams {
  [property: string]: any;
}
